<template>
  <v-layout column class="inner-pages">
    <Header  />

     <v-flex class="sfh-login-form background-image text-xs-center signup-page scrollbar scroll-style-15" >

      <v-stepper v-model="e1" class="elevation-0" style="background: transparent;">
        <v-stepper-header class="elevation-0 px-4" v-if="e1 !== 5">
          <v-stepper-step :complete="e1 > 1" step="1"></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2"></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3"></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 4" step="4"></v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <confirm-my-email
              v-if="step === 'confirm-my-email'"
            />
            <code-verification
              v-if="step === 'code-verification'"
            />
          </v-stepper-content>

          <v-stepper-content step="2">
            <confirm-my-phone
              v-if="step === 'confirm-my-phone'"
            />
            <phone-code-verification
              v-if="step === 'phone-verification'"
            />
          </v-stepper-content>

          <v-stepper-content step="3">
            <confirm-name />
          </v-stepper-content>

          <v-stepper-content step="4">
            <get-name-and-pwd />
          </v-stepper-content>

          <v-stepper-content step="5">
            <confirm-pwd />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-flex>
  </v-layout>
</template>

<script>
import Header from '../../layouts/Header'
import ConfirmMyEmail from './ConfirmMyEmail'
import CodeVerification from './CodeVerification'
import GetNameAndPwd from './GetLocationInfo'
import ConfirmPwd from './ConfirmPwd'
import ConfirmMyPhone from './ConfirmMyPhone'
import PhoneCodeVerification from './PhoneCodeVerification'
import {mapGetters} from 'vuex'
import ConfirmName from './ConfirmName'

export default {
  name: 'SignUp',
  components: {
    ConfirmName,
    PhoneCodeVerification,
    ConfirmMyPhone,
    GetNameAndPwd,
    CodeVerification,
    ConfirmMyEmail,
    Header,
    ConfirmPwd
  },
  data () {
    return {
      e1: 1
    }
  },
  computed: {
    step () {
      return this.$route.params.step
    },
    ...mapGetters('registration', ['getUserDetails'])
  },
  created () {
    this.setE1(this.$route.params.step)
    setTimeout(() => {
      this.$store.commit('setIsCompactHeader', false)
    }, 50)
  },
  methods: {
    setE1 (newVal) {
      switch (newVal) {
        case 'confirm-my-email': this.e1 = 1
          break
        case 'code-verification': this.e1 = 1
          break
        case 'confirm-my-phone': this.e1 = 2
          break
        case 'phone-verification': this.e1 = 2
          break
        case 'confirm-name': this.e1 = 3
          break
        case 'get-location-info': this.e1 = 4
          break
        case 'confirm-pwd': this.e1 = 5
          break
        default: this.e1 = 1
      }
    }
  },
  watch: {
    step (newVal) {
      this.setE1(newVal)
    }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/sign-up/SignUp.vue